import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[emRequiredMark]',
  standalone: true,
})
export class RequiredMarkDirective implements OnInit {

  constructor(private renderer: Renderer2, private element: ElementRef) {
  }

  ngOnInit() {
    const span = this.renderer.createElement('span');
    span.classList.add('ml-1', 'text-2xl', 'font-medium', 'text-red-500');
    const text = this.renderer.createText('*');
    this.renderer.appendChild(span, text);
    this.renderer.appendChild(this.element.nativeElement, span);
  }
}
